import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=357943ca&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=357943ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357943ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357943ca')) {
      api.createRecord('357943ca', component.options)
    } else {
      api.reload('357943ca', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=357943ca&scoped=true&", function () {
      api.rerender('357943ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZQJs7ffVeZEG/JS/teamMember.vue"
export default component.exports